import SendIcon from '@mui/icons-material/Send'
import { memo, useCallback, useEffect, useState } from 'react'
import { Mention, MentionsInput } from 'react-mentions'
import { menuInputStyle, mentionStyle } from './menuInputStyle'
import {
  BtnToolTipWrapper,
  ConversationCreateMessageStyles,
  InputContainerStylesDiv,
  SendButtonWrapper,
} from './NotesInput.styles'
import { Tooltip, Typography } from '@mui/material'

interface NotesInputProps {
  onSend: (value: string) => void
  data: {
    id: string | number
    display: string
  }[]
  initialValue?: string
  loading: boolean
  personId: number
  hasAccess?: boolean
}

const NotesInput = ({
  onSend,
  data,
  initialValue = '',
  personId,
  hasAccess,
}: NotesInputProps) => {
  const [sending, setSending] = useState(false)
  const [value, setValue] = useState(initialValue)
  const onChange = useCallback((_, newValue) => setValue(newValue), [setValue])

  useEffect(() => {
    if (personId && !initialValue) {
      setValue('')
    }
  }, [initialValue, personId])

  const onSubmit = useCallback(async () => {
    try {
      setSending(true)
      await onSend(value)
      setValue('')
    } finally {
      setSending(false)
    }
  }, [onSend, value])

  return (
    <ConversationCreateMessageStyles>
      <InputContainerStylesDiv>
        <MentionsInput
          trigger="@"
          value={value}
          onChange={onChange}
          placeholder="Write a message... Mention people using '@'"
          a11ySuggestionsListLabel={'Suggested mentions'}
          style={menuInputStyle}
          allowSuggestionsAboveCursor={false}
        >
          <Mention data={data} style={mentionStyle} />
        </MentionsInput>
      </InputContainerStylesDiv>
      {hasAccess ? (
        <SendButtonWrapper
          onClick={onSubmit}
          variant="text"
          isLoading={sending}
          disabled={sending || !value || value.length > 250}
        >
          {value.length > 250 && (
            <Typography color={'error'}>
              notes can not be more than 250
            </Typography>
          )}

          <SendIcon />
        </SendButtonWrapper>
      ) : (
        <Tooltip
          title="Sorry you don't have permissions for this."
          placement="left"
        >
          <BtnToolTipWrapper>
            <SendButtonWrapper variant="text" disabled>
              {value.length > 250 && (
                <Typography color={'error'}>
                  notes can not be more than 250
                </Typography>
              )}
              <SendIcon />
            </SendButtonWrapper>
          </BtnToolTipWrapper>
        </Tooltip>
      )}
    </ConversationCreateMessageStyles>
  )
}

export default memo(NotesInput)
